module.exports = __webpack_public_path__ + "img/26_newYouth_wxh.59c9e5a3.png";